import { render, staticRenderFns } from "./IconSortDecrease.vue?vue&type=template&id=3c593fdf&"
import script from "./IconSortDecrease.vue?vue&type=script&lang=js&"
export * from "./IconSortDecrease.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports